
window.Glide = window.Glide || {};

frappe.ready(function() {
    initWebcommerce();
});

function initWebcommerce() {
    initCarousel();
    initProductActions();
    initFlashSaleCountdown();
    initSmoothScrolling();
    initProductFilters();
}

function initCarousel() {
    const carouselElement = document.getElementById('banner-carousel');
    if (carouselElement && window.Glide) {
        try {
            const glide = new Glide('#banner-carousel', {
                type: 'carousel',
                startAt: 0,
                perView: 1,
                autoplay: 5000,
                hoverpause: true,
                animationDuration: 800,
                animationTimingFunc: 'ease-in-out'
            });

            glide.mount();
            window.webcommerceCarousel = glide;
        } catch (error) {
            console.warn('Glide banner carousel initialization failed:', error);
        }
    }

    const flashSaleCarousel = document.getElementById('flash-sale-carousel');
    if (flashSaleCarousel && window.Glide) {
        try {
            const glideFlashSale = new Glide('#flash-sale-carousel', {
                type: 'carousel',
                startAt: 0,
                perView: 4,
                autoplay: 3000,
                hoverpause: true,
                gap: 20,
                breakpoints: {
                    1200: { perView: 3 },
                    992: { perView: 2 },
                    768: { perView: 2 },
                    576: { perView: 1 }
                }
            });

            glideFlashSale.mount();
            window.flashSaleCarousel = glideFlashSale;
        } catch (error) {
            console.warn('Glide flash sale carousel initialization failed:', error);
        }
    }

    const featuredCarousel = document.getElementById('featured-products-carousel');
    if (featuredCarousel && window.Glide) {
        try {
            const glideFeatured = new Glide('#featured-products-carousel', {
                type: 'carousel',
                startAt: 0,
                perView: 4,
                autoplay: 4000,
                hoverpause: true,
                gap: 20,
                breakpoints: {
                    1200: { perView: 3 },
                    992: { perView: 2 },
                    768: { perView: 2 },
                    576: { perView: 1 }
                }
            });

            glideFeatured.mount();
            window.featuredProductsCarousel = glideFeatured;
        } catch (error) {
            console.warn('Glide featured products carousel initialization failed:', error);
        }
    }
}

function initProductActions() {
    window.addToCart = function(itemCode, qty = 1) {
        if (!itemCode) return;

        const button = event.target;
        const originalText = button.innerHTML;
        button.innerHTML = '<span class="webcommerce-loading"></span>';
        button.disabled = true;

        frappe.call({
            method: "tos_webcommerce.api.cart.update_cart",
            args: {
                item_code: itemCode,
                qty: qty,
                with_items: 1
            },
            callback: function(r) {
                button.innerHTML = originalText;
                button.disabled = false;

                if (!r.exc && r.message) {
                    showAlert(__("Item added to cart"), "success");
                    updateCartCount();
                } else {
                    showAlert(r.exc || __("Unable to add item to cart"), "error");
                }
            },
            error: function(r) {
                button.innerHTML = originalText;
                button.disabled = false;
                showAlert(__("An error occurred"), "error");
            }
        });
    };

    window.addToWishlist = function(itemCode) {
        if (!itemCode) return;

        frappe.call({
            method: "tos_webcommerce.commerce.api.update_wishlist",
            args: {
                item_code: itemCode,
                action: "add"
            },
            callback: function(r) {
                if (!r.exc) {
                    showAlert(__("Item added to wishlist"), "success");
                } else {
                    showAlert(__("Unable to add item to wishlist"), "error");
                }
            }
        });
    };
}

function initFlashSaleCountdown() {
    const countdownElement = document.getElementById('flash-sale-countdown');
    if (!countdownElement) return;

    function updateCountdown() {
        frappe.call({
            method: 'tos_webcommerce.api.product.get_flash_sale_countdown',
            callback: function(r) {
                if (r.message) {
                    updateCountdownDisplay(r.message);
                } else {
                    countdownElement.innerHTML = '<h5 class="text-center mb-0">Flash Sale Ended!</h5>';
                }
            }
        });
    }

    function updateCountdownDisplay(timeData) {
        const elements = {
            days: document.getElementById('days'),
            hours: document.getElementById('hours'),
            minutes: document.getElementById('minutes'),
            seconds: document.getElementById('seconds')
        };

        if (elements.days) elements.days.textContent = timeData.days;
        if (elements.hours) elements.hours.textContent = timeData.hours;
        if (elements.minutes) elements.minutes.textContent = timeData.minutes;
        if (elements.seconds) elements.seconds.textContent = timeData.seconds;
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);
}

function initSmoothScrolling() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            const href = this.getAttribute('href');
            if (!href || href === '#') {
                return;
            }
            
            const target = document.querySelector(href);
            if (target) {
                e.preventDefault();
                target.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        });
    });
}

function initProductFilters() {
    window.applySorting = function(sortValue) {
        const url = new URL(window.location.href);
        url.searchParams.set('sort', sortValue);
        url.searchParams.delete('page');
        window.location.href = url.toString();
    };

    const filterToggle = document.getElementById('filter-toggle');
    const filterSidebar = document.querySelector('.filters-sidebar');

    if (filterToggle && filterSidebar) {
        filterToggle.addEventListener('click', function() {
            filterSidebar.classList.toggle('show');
        });
    }
}

function updateCartCount() {
    if (!frappe.session || frappe.session.user === 'Guest') {
        return;
    }
    frappe.call({
        method: "tos_webcommerce.api.cart.get_cart_quotation",
        callback: function(r) {
            if (r.message && r.message.doc) {
                const totalQty = r.message.doc.total_qty || 0;
                const cartBadges = document.querySelectorAll('.cart-count');
                cartBadges.forEach(badge => {
                    badge.textContent = totalQty;
                    badge.style.display = totalQty > 0 ? 'inline' : 'none';
                });
            }
        }
    });
}

function showAlert(message, type = 'info') {
    if (window.frappe && frappe.show_alert) {
        const indicator = type === 'success' ? 'green' : type === 'error' ? 'red' : 'blue';
        frappe.show_alert({
            message: message,
            indicator: indicator
        });
    } else {
        alert(message);
    }
}

function getUrlParameter(name) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
}

function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}

function initLazyLoading() {
    if ('IntersectionObserver' in window) {
        const imageObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const img = entry.target;
                    img.src = img.dataset.src;
                    img.classList.remove('lazy');
                    imageObserver.unobserve(img);
                }
            });
        });

        document.querySelectorAll('img[data-src]').forEach(img => {
            imageObserver.observe(img);
        });
    }
}

function initTooltips() {
    if (window.bootstrap && bootstrap.Tooltip) {
        const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
        tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new bootstrap.Tooltip(tooltipTriggerEl);
        });
    }
}

function initResponsiveNavigation() {
    const navToggle = document.querySelector('.navbar-toggler');
    const navCollapse = document.querySelector('.navbar-collapse');

    if (navToggle && navCollapse) {
        navToggle.addEventListener('click', function() {
            navCollapse.classList.toggle('show');
        });
    }
}

document.addEventListener('DOMContentLoaded', function() {
    initLazyLoading();
    initTooltips();
    initResponsiveNavigation();
});

window.webcommerceUtils = {
    showAlert,
    getUrlParameter,
    debounce,
    updateCartCount,
    addToCart: window.addToCart,
    addToWishlist: window.addToWishlist,
};
